export const BULK_UPDATE_CHANGE_DESCRIPTION = "BULK_UPDATE_CHANGE_DESCRIPTION" 
export const BULK_UPDATE_COPY_METADATA = "BULK_UPDATE_COPY_METADATA" 
export const FOOTAGE_CREDITS = "(Footage by Aerologix/Getty Images)"